import { render, staticRenderFns } from "./logwood-home.vue?vue&type=template&id=2a43dfb3&"
import script from "./logwood-home.vue?vue&type=script&lang=ts&"
export * from "./logwood-home.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a43dfb3')) {
      api.createRecord('2a43dfb3', component.options)
    } else {
      api.reload('2a43dfb3', component.options)
    }
    module.hot.accept("./logwood-home.vue?vue&type=template&id=2a43dfb3&", function () {
      api.rerender('2a43dfb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/views/logwood-home.vue"
export default component.exports